import React, { useState } from "react";
import cx from "classnames";
import styles from "./MyAccount.module.scss";
import { useCurrentPatient } from "./hooks/useCurrentPatient";
import { useMsal } from "@azure/msal-react";
import chevronUpIcon from "images/arrow-up-new.png";
import chevronDownIcon from "images/arrow-down-new.svg";
import myAccountIcon from "images/my-account.svg";

const ACCOUNT_CHECK_INTERVAL_MS = 15_000;

export const MyAccountCAIM: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { handleLogoutRedirect } = useCurrentPatient();
  const { instance } = useMsal();

  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      const account = instance.getActiveAccount();
      if (!account) {
        instance.logoutRedirect();
      }
    }, ACCOUNT_CHECK_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [instance]);

  return (
    <>
      <button
        onClick={() => setOpen((currentValue) => !currentValue)}
        className={styles.myAccountButton}
      >
        <img src={myAccountIcon} alt="my account icon" /> My Account{" "}
        {isOpen ? (
          <img src={chevronUpIcon} alt="chevron up icon" />
        ) : (
          <img src={chevronDownIcon} alt="chevron down icon" />
        )}
      </button>
      {isOpen && (
        <div className={styles.subButtonsCIAM}>
          <button
            id="logout"
            onClick={handleLogoutRedirect}
            className={cx(styles.subButton, styles.bottomButton)}
          >
            Log Out
          </button>
        </div>
      )}
    </>
  );
};
